'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isElemVisibleHorizontally = exports.isElemVisibleHorizontally = function isElemVisibleHorizontally(el, wrapper) {
  return isElemVisible(el, 'right', wrapper, window.innerWidth || document.documentElement.clientWidth);
};

var isElemVisibleVertically = exports.isElemVisibleVertically = function isElemVisibleVertically(el, wrapper) {
  return isElemVisible(el, 'bottom', wrapper, window.innerHeight || document.documentElement.clientHeight);
};

var isElemVisible = function isElemVisible(el, direction) {
  var wrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var condition = arguments[3];

  var dir = el.getBoundingClientRect()[direction];

  var honourCondition = wrapper ? dir <= document.getElementById(wrapper).getBoundingClientRect()[direction] : true;

  return dir <= condition && honourCondition;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@billes/components/lib/utils/isElemVisible.js
// module id = 405
// module chunks = 5